import { Component, HostBinding, inject, input } from '@angular/core';
import { NativeCallService } from 'src/app/services/native-call.service';

@Component({
  imports: [],
  selector: 'app-call-main',
  standalone: true,
  styleUrls: ['./call-main.css'],
  templateUrl: './call-main.html',
})
export class CallMainComponent {
  isLoading = input(false);

  private readonly nativeCallService = inject(NativeCallService);

  @HostBinding('class')
  protected get cssClass() {
    return {
      isLoading: !!this.isLoading(),
      'native-ios': this.nativeCallService.isNativeIos,
    };
  }
}
